export const ENTER_EASE = [0.22, 1, 0.36, 1] as const
export const ENTER_DURATION = 0.4
export const CROSSFADE_DURATION = 0.2
export const COLUMN_DURATION = 0.35
export const ITEMS_DELAY = 0.08
export const ITEM_STAGGER = 0.06

export function enterTransition(
  delay: number,
  enabled: boolean,
  { y = true, visible }: { y?: boolean; visible?: boolean } = {}
) {
  if (!enabled) return { initial: false as const }

  const hidden = y ? { opacity: 0, y: 8 } : { opacity: 0 }
  const shown = y ? { opacity: 1, y: 0 } : { opacity: 1 }
  const transition = { duration: ENTER_DURATION, ease: ENTER_EASE, delay }

  if (visible !== undefined) {
    return { initial: false as const, animate: visible ? shown : hidden, transition }
  }

  return { initial: hidden, animate: shown, transition }
}
